/**
 * Copyright (C) 2017-2018 System Clinic Inc. All rights reserved.
 * This file is the property of System Clinic Inc.
 *
 * File: NoPrivilege.js
 * Author: Naoaki Suganuma
 * Update: 2018/3/12
 * Version: 1.0.0
 */

import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import withTheme from '../withTheme';

/**
 * スタイル情報 
 */
const styles = theme => ({
  base: {
    flex: "1 1 auto",
    display: "flex",
    position: "relative",
    overflow: "hidden",
  },
  div: {
    minWidth: 320,
    maxWidth: 400,
    height: 'auto',
    position: 'absolute',
    top: '20%',
    left: 0,
    right: 0,
    margin: 'auto',
  },
  paper: {
    padding: 20,
    overflow: 'auto',
  },
});

/**
 * NoPrivilegeコンポーネント
 */
class NoPrivilege extends Component {
  /**
   * NoPrivilegeコンポーネントのレンダリング
   */
  render() {
    return (
      <div className={this.props.classes.base}>
        <div className={this.props.classes.div}>
          <Paper className={this.props.classes.paper}>
            アクセス権限がありません。
          </Paper>
        </div>
      </div>
    );
  }
}

/**
 * Themeの適用
 */
export default withTheme(withStyles(styles)(NoPrivilege))